/* eslint-disable max-depth */
export const urls = {
    disable: id => `/api/items/${id}/disable`,
    myAdsFilters: userId => `/api/v3/myads-configurations/${userId}/filter`
};

export const initialState = {
    openRemoveAfterMarkAsSold: false,
    items: [],
    filters: {},
    // SORTING CAN BE APPLIED ON ANY EXPIRING ADS, HIGHLIHTED ADS AS WELL AS NORMAL ADS, HENCE KEEPING IT SEPARATE
    sortBy: '',
    // AT ANY TIME EITHER EXPIRING ADS CAN BE SELECTED OR NORMAL ADS CHIPS CAN BE SELECTED HENCE KEEPING ONLY ONE MAP FOR BOTH
    userSelectedFilters: {
        filterGroupId: '',
        options: {}
    }
};

const transformFiltersData = filtersData => {
    try {
        if (filtersData.filterMap) {
            const keys = Object.keys(filtersData.filterMap);
            const filterTypeKeyMap = {};

            for (const identifier of keys) {
                filterTypeKeyMap[filtersData.filterMap[identifier].type] = identifier;
                if (filtersData.filterMap[identifier].defaultSort) {
                    filterTypeKeyMap.defaultSort = filtersData.filterMap[identifier].defaultSort;
                }
                const options = filtersData.filterMap[identifier].options;

                if (options && Array.isArray(options)) {
                    for (const option of options) {
                        filterTypeKeyMap[option.key] = option.title;
                    }
                }
            }
            filtersData.filterTypeKeyMap = filterTypeKeyMap;
        }
        return filtersData;
    }
    catch (error) {
        return filtersData;
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REMOVE_MARK_AS_SOLD_MYAD':
            return {
                ...state,
                openRemoveAfterMarkAsSold: action.data
            };
        case 'RECEIVE_MYADS': {
            const myAdsItems = state.items || {};
            const items = { ...myAdsItems, [action.currentPage]: action.data.data };

            return {
                ...state,
                items
            };
        }
        case 'RECEIVE_MYADS_FILTERS': {
            return {
                ...state,
                filters: transformFiltersData(action.data.data)
            };
        }
        case 'UPDATE_SORT_OPTION': {
            return {
                ...state,
                sortBy: action.value
            };
        }
        case 'UPDATE_USER_FILTERS': {
            const { myAdsfilters } = action;

            return {
                ...state,
                userSelectedFilters: myAdsfilters
            };
        }
        default:
            return state;
    }
};
